module.exports = __webpack_public_path__ + "img/wrapbg4.3a6f51ca.png";